/* section-bbb-collection.js — BBB collection filter/sort with AJAX (no full reload).
   - Dropdowns: one <details data-bbb-dd> open at a time; close on outside click / Escape.
   - Apply / sort / chips / clear / clear-all / pagination fetch the target URL and swap
     the results, filters, active chips and count in place, then sync history.
   - Progressive enhancement: with JS off, everything still works as plain links + a GET
     form (full reload). */
(function () {
  var SWAP = ['[data-bbb-results]', '[data-bbb-filters]', '[data-bbb-active]', '[data-bbb-bar-right]'];

  function cleanUrlFromForm(form) {
    var params = new URLSearchParams(new FormData(form));
    var clean = new URLSearchParams();
    params.forEach(function (v, k) {
      if (v !== '' && v != null) clean.append(k, v);
    });
    var base = form.getAttribute('action') || location.pathname;
    var qs = clean.toString();
    return qs ? base + '?' + qs : base;
  }

  function render(root, url, opts) {
    opts = opts || {};
    root.setAttribute('aria-busy', 'true');
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-bbb-collection]');
        if (!next) { window.location.assign(url); return; }
        SWAP.forEach(function (sel) {
          var cur = root.querySelector(sel);
          var incoming = next.querySelector(sel);
          if (cur && incoming) cur.innerHTML = incoming.innerHTML;
        });
        var active = root.querySelector('[data-bbb-active]');
        if (active) active.hidden = active.children.length === 0;
        if (!opts.replace) history.pushState({ bbbColl: true }, '', url);
        root.removeAttribute('aria-busy');
        if (opts.scroll) {
          var top = root.getBoundingClientRect().top + window.pageYOffset - 20;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      })
      .catch(function () {
        // Network/parse failure — fall back to a normal navigation.
        window.location.assign(url);
      });
  }

  // Position a dropdown panel under its pill using viewport (fixed) coordinates so it
  // can't be clipped/hidden by any ancestor's overflow or stacking context.
  function positionPanel(dd) {
    var summary = dd.querySelector('summary');
    var panel = dd.querySelector('.bbb-coll__panel');
    if (!summary || !panel) return;
    var r = summary.getBoundingClientRect();
    var vw = document.documentElement.clientWidth;
    var pw = panel.offsetWidth || 240;
    var left = dd.classList.contains('bbb-coll__sort') ? r.right - pw : r.left;
    left = Math.max(8, Math.min(left, vw - pw - 8));
    panel.style.left = left + 'px';
    panel.style.top = r.bottom + 10 + 'px';
  }

  function repositionOpen(root) {
    var dd = root.querySelector('[data-bbb-dd][open]');
    if (dd) positionPanel(dd);
  }

  function initRoot(root) {
    if (root.__bbbColl) return;
    root.__bbbColl = true;

    var form = root.querySelector('form[id^="BbbCollForm"]');

    // Close other dropdowns when one opens; position the one that opened.
    root.addEventListener('toggle', function (e) {
      var dd = e.target;
      if (!dd.matches('[data-bbb-dd]')) return;
      if (!dd.open) return;
      root.querySelectorAll('[data-bbb-dd][open]').forEach(function (other) {
        if (other !== dd) other.open = false;
      });
      positionPanel(dd);
    }, true);

    // Keep the open panel glued to its pill while scrolling/resizing.
    var raf;
    var onMove = function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { repositionOpen(root); });
    };
    window.addEventListener('scroll', onMove, { passive: true });
    window.addEventListener('resize', onMove);

    // Apply (form submit) → fetch from the form's checkbox/price state.
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        render(root, cleanUrlFromForm(form));
        var open = root.querySelector('[data-bbb-dd][open]');
        if (open) open.open = false;
      });
    }

    // Clicks: sort options + filter/chip/pagination links.
    root.addEventListener('click', function (e) {
      var sortBtn = e.target.closest('[data-bbb-sort]');
      if (sortBtn && root.contains(sortBtn)) {
        e.preventDefault();
        var hidden = form && form.querySelector('input[name="sort_by"]');
        if (hidden) hidden.value = sortBtn.getAttribute('data-bbb-sort');
        render(root, cleanUrlFromForm(form));
        var dd = sortBtn.closest('[data-bbb-dd]');
        if (dd) dd.open = false;
        return;
      }

      var link = e.target.closest(
        '.bbb-coll__chip, .bbb-coll__clear, .bbb-coll__clear-all, .bbb-coll__pagination a'
      );
      if (link && root.contains(link) && link.getAttribute('href')) {
        e.preventDefault();
        var isPage = !!link.closest('.bbb-coll__pagination');
        render(root, link.href, { scroll: isPage });
      }
    });
  }

  function wireGlobal() {
    document.addEventListener('click', function (e) {
      document.querySelectorAll('[data-bbb-dd][open]').forEach(function (dd) {
        if (!dd.contains(e.target)) dd.open = false;
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('[data-bbb-dd][open]').forEach(function (dd) {
        dd.open = false;
        var s = dd.querySelector('summary');
        if (s) s.focus();
      });
    });
    window.addEventListener('popstate', function () {
      var root = document.querySelector('[data-bbb-collection]');
      if (root) render(root, location.href, { replace: true });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-bbb-collection]').forEach(initRoot);
  }

  if (document.readyState !== 'loading') {
    initAll();
    wireGlobal();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
      wireGlobal();
    });
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.matches('[data-bbb-collection]')
      ? e.target
      : e.target.querySelector('[data-bbb-collection]');
    if (root) initRoot(root);
  });
})();
